export default {
  'enable-auto-complete': true,
  debug: process.env.NODE_ENV === 'development',
  'api-baseurl': process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : ''
}
